import React from "react";
import Img01 from "../../images/profile.jpg"
import { useStaticQuery, graphql, Link } from "gatsby"
import _ from "lodash"
import { PageLinks } from "../../common/page-links";
import "./Contact.scss";

const Contact = ({ property_data }) => {

    const data = useStaticQuery(graphql`
    query TeamMemberQuery{
      glstrapi {
        teams {
          id
          name
          slug
          tile_image {
            alternativeText
            url
          }
          title
          video_url
          mobile_no
          designation
          email 
          offices {
            email
            _id
            name
            slug
          }
        }
      }
    }`)

    var teams = data.glstrapi?.teams;
    let filtered_team = _.find(teams, function (o) { return o.email?.toLowerCase() === property_data?.crm_negotiator_id?.email?.toLowerCase(); }); 

    //console.log("filtered_team", filtered_team);

    return (
        <React.Fragment>
            <section className="contact-us d-xl-none">
                {filtered_team && filtered_team?.id ?
                    <div className="contact-wrapper">
                        <div className="contact-img">
                            <img src={filtered_team?.tile_image?.url} alt="contact-img" />
                        </div>
                        <div className="contact-info"> 
                            <div className="h3">{filtered_team?.name}</div> 
                            <div className="h4">{filtered_team?.designation}</div>
                            <div className="contact-wrap">
                                {filtered_team?.offices?.length > 0 ?
                                    <Link to={`/${PageLinks.branch_finder}/${filtered_team?.offices[0]?.slug}/${PageLinks.branch_contact}/`} className="branch-name">Branch</Link>
                                :
                                    <Link to={`/${PageLinks.branch_finder}/`} className="branch-name">Branch</Link>
                                }

                                <Link to={`/${PageLinks.teams}/${filtered_team.slug}/${PageLinks.team_contact}/`} state={{to_email_id:filtered_team?.email}}>Email Me</Link> 
                            </div>
                        </div>
                    </div> :
                    <div className="contact-wrapper">
                        <div className="contact-img">
                            <img src={Img01} alt="contact-img" />
                        </div>
                        <div className="contact-info">
                            {property_data?.crm_negotiator_id?.name &&
                                <div className="h3">{property_data?.crm_negotiator_id?.name}</div>
                            }
                            <div className="h4">&nbsp;</div>
                            <div className="contact-wrap">
                                <Link to={`/${PageLinks.branch_finder}/`} className="branch-name">Branch</Link>
                                <Link to={`/${PageLinks.general_enquiry}/`} state={{to_email_id:property_data?.crm_negotiator_id?.email}} className="branch-name">Email Me</Link>        
                               
                            </div>
                        </div>
                    </div>
                }

            </section>
        </React.Fragment>
    );
};
export default Contact;
